var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackButtonDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 38,
    viewBox: "0 0 56 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 38,
    rx: 19,
    transform: "matrix(-1 0 0 1 56 0)",
    fill: "#E8F3FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2929 19.7071C14.9024 19.3166 14.9024 18.6834 15.2929 18.2929L21.6569 11.9289C22.0474 11.5384 22.6805 11.5384 23.0711 11.9289C23.4616 12.3195 23.4616 12.9526 23.0711 13.3431L17.4142 19L23.0711 24.6569C23.4616 25.0474 23.4616 25.6805 23.0711 26.0711C22.6805 26.4616 22.0474 26.4616 21.6569 26.0711L15.2929 19.7071ZM40 20L16 20L16 18L40 18L40 20Z",
    fill: "#3880F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButtonDesktop);
export default __webpack_public_path__ + "static/media/back-button-desktop.6948e7943f4cf7080a12d5438e1b7109.svg";
export { ForwardRef as ReactComponent };